var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form-button-disabler", [
    _c("div", { staticClass: "w-full flex pt-2 flex-col" }, [
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _vm.packageType === "buy"
            ? _c(
                "field",
                {
                  staticClass: "mb-2",
                  attrs: { disabled: _vm.disableBuyer },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c(
                              "label",
                              { staticClass: "flex pb-1" },
                              [
                                _c("span", [_vm._v("Buyer Name")]),
                                _c("icon-info", {
                                  staticClass: "pl-2",
                                  attrs: {
                                    mini: "",
                                    title:
                                      "Buyer can only be updated while in Bid status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2170177278
                  ),
                },
                [
                  _vm._v(" "),
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.buyerSource,
                      "text-field": "name",
                      placeholder: "Select Buyer",
                    },
                    model: {
                      value: _vm.selectedBuyer,
                      callback: function ($$v) {
                        _vm.selectedBuyer = $$v
                      },
                      expression: "selectedBuyer",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.packageType === "sell"
            ? _c(
                "field",
                {
                  staticClass: "mb-2",
                  attrs: { label: "Buyer Name", disabled: _vm.disableBuyer },
                },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.buyerSource,
                      "text-field": "name",
                      placeholder: "Select Buyer",
                      searchable: "",
                    },
                    model: {
                      value: _vm.selectedBuyer,
                      callback: function ($$v) {
                        _vm.selectedBuyer = $$v
                      },
                      expression: "selectedBuyer",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.packageType === "buy"
            ? _c(
                "field",
                {
                  staticClass: "mb-2",
                  attrs: { label: "Seller Name", disabled: "" },
                },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: [_vm.seller],
                      "text-field": "name",
                      placeholder: "Select Seller",
                    },
                    model: {
                      value: _vm.seller,
                      callback: function ($$v) {
                        _vm.seller = $$v
                      },
                      expression: "seller",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.packageType === "buy"
            ? _c(
                "field",
                { staticClass: "mb-2", attrs: { label: "To Package" } },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.packageSource,
                      "text-field": "packageName",
                      placeholder: "Select Package",
                    },
                    model: {
                      value: _vm.package,
                      callback: function ($$v) {
                        _vm.package = $$v
                      },
                      expression: "package",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.packageType === "sell"
            ? _c(
                "field",
                { staticClass: "mb-2", attrs: { label: "To Deal" } },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.packageSource,
                      "text-field": "dealName",
                      placeholder: "Select Deal",
                    },
                    model: {
                      value: _vm.package,
                      callback: function ($$v) {
                        _vm.package = $$v
                      },
                      expression: "package",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "field",
            { staticClass: "mb-2", attrs: { label: "Reason" } },
            [
              _c("textarea-field", {
                model: {
                  value: _vm.description,
                  callback: function ($$v) {
                    _vm.description = $$v
                  },
                  expression: "description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-row-reverse pt-4" },
        [
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Move Loans")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }